import { render, staticRenderFns } from "./DropdownSplit.vue?vue&type=template&id=59e9dc1e"
import script from "./DropdownSplit.vue?vue&type=script&lang=js"
export * from "./DropdownSplit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports